export default "__VITE_ASSET__SVp8zqeZ__"